




























































































import Vue from 'vue'

const DIRECTIONS_URL_BASIS = 'https://www.google.com/maps/dir/?api=1'

export default Vue.extend({
  props: {
    places: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sortedPlaces (): any[] {
      const items = Array.isArray(this.places) ? [...this.places] : []
      return items.sort((a: any, b: any) => {
        const aHit = a && a.has_schedule_event ? 0 : 1
        const bHit = b && b.has_schedule_event ? 0 : 1
        if (aHit !== bHit) {
          return aHit - bHit
        }
        const aDist = a && a.distance_m != null ? Number(a.distance_m) : Number.POSITIVE_INFINITY
        const bDist = b && b.distance_m != null ? Number(b.distance_m) : Number.POSITIVE_INFINITY
        if (aDist !== bDist) {
          return aDist - bDist
        }
        return String(a && a.name || '').localeCompare(String(b && b.name || ''))
      })
    }
  },
  methods: {
    formatScheduleEvent (ev: any) {
      if (!ev) {
        return ''
      }
      const when = ev.from_date ? new Date(ev.from_date).toLocaleString(undefined, {
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit'
      }) : ''
      return when ? `${when} — ${ev.name}` : ev.name
    },
    formatDistance (meters: number) {
      if (meters == null || isNaN(Number(meters))) {
        return ''
      }
      const km = Number(meters) / 1000
      if (km < 1) {
        return `${Math.round(Number(meters))} m`
      }
      return `${km.toFixed(km < 10 ? 1 : 0)} km`
    },
    directionsLink (address: string) {
      const url = new URL(DIRECTIONS_URL_BASIS)
      url.searchParams.set('destination', address)
      return url.toString()
    },
    placeSeoUrl (place: any) {
      const alias = place && place.alias
      if (!alias || typeof alias !== 'string') {
        return null
      }
      return `/lokal/${encodeURIComponent(alias)}`
    }
  }
})
